<template>
  <div class="workOrders">
    <van-cell-group>
      <van-cell
        v-for="(item, index) in formList"
        :key="index"
        :title="item.value"
        :value="formData[item.key]"
      />
      <van-cell title="救援环境">
        <template #right-icon>
          <van-checkbox-group
            style="width: 65%;"
            v-model="dataForm.rescueEnvironment"
            direction="horizontal"
          >
            <van-checkbox
              v-for="(item, index) in checkList"
              :key="index"
              :name="item"
              icon-size="16px"
              shape="square"
            >{{ item }}</van-checkbox>
          </van-checkbox-group>
        </template>
      </van-cell>
      <van-cell
        title="*故障原因"
        title-style="color: #F32222;"
      >
        <template #right-icon>
          <van-field
            style="width: 65%;padding: 0;font-weight: 500;"
            v-model="dataForm.carStatus"
            maxlength="20"
            name="pattern"
            placeholder="请填写"
          />
        </template>
      </van-cell>
    </van-cell-group>
    <div class="agreement">
      <div class="title">服务须知及免责协议(请顾客认真阅读并在理解且无异议后签字确认)</div>
      <div class="title">免责协议：</div>
      <div class="info">1、如需实施外部救援行为(含困境，地库拖车，吊车等)，在救援师傅实施救援操作无过错的情况下，为了完成救援而导致的车辆不可避免的车辆损伤，顾客确认自行承担此类风险和损失 </div>
      <div class="info">2、确认已完全悉知本记录单服务须知第11点</div>
      <div class="title">服务须知:</div>
      <div class="info">1、救援师傅经救援机构授权，按照法律法规及合同内容提供道路救援服务保留不提供超出救援服务范围服务的权利。如有特殊情况，请顾客与救援机构联系</div>
      <div class="info">2、顾客应配合救援人员检查辆外观状况并签字确认。救援机构不接受签字确认的车辆损伤情况的索赔要求</div>
      <div class="info">3、因无法预见或人力无法抗拒的自然或人为因素(包括但不限于恶劣天气等不可抗力、交通管制、第三方事故等)造成服务延迟，导致顾客行程延误、活动取消、财产受损及人员伤害等直接或间接损失，救援师傅和救援机构不承担责任</div>
      <div class="info">4、路边维修仅是临时性采取必要措施，使车辆恢复行使顾客应尽快前往专业车辆维修机构检测维修</div>
      <div class="info">5、对于涉水车辆，仅提供拖车服务，将故障/事故车辆拖往修理厂或经销商处检修。如顾客要求救援师傅(或者自行或委托第三方)违反上述要求对涉水车辆进行其他操作 需要自行承担后果</div>
      <div class="info">6、顾客如果要求自费服务项目，请与第三方协商相关费用并现场向其支付。因为此类服务发生任何争议，请与第三方或救援师傅自行解决，教援机构不再介入和负责</div>
      <div class="info">7、拖车服务时，救援师傅仅按照救援机构的指令，将车辆拖往指定目的地，如果顾客需要变更拖车目的地，请与救援机构联系</div>
      <div class="info">8、拖车服务时救援师傅和救援机构仅负责将故障、事故车辆拖往指定目的地顾客需采取其他方式离开现场。如果顾客坚持乘坐拖车离开顾客应自行或通过救援师傅向救援机构说明，并确认知悉搭乘风险和自愿自行承担搭乘过程中可能发生的交通事故等造成人身伤害和财损失的风险保证不以任何理由要求救援机构或救援师傅赔偿同时，顾客应保证搭乘时不干扰救援师傅驾驶救援车辆，否则，应承担全部责任</div>
      <div class="info">9、顾客应保证车辆手续、保险齐全否则，顾客须对其因隐瞒真实情况而造成的损失等承担全部责任</div>
      <div class="info">10、救援服务过程中，顾客不得干扰救援师傅正常工作不得要求救援师傅违反交通法规等操作和行驶，不得要求救援师傅提供一切违法和超出服务范围的服务。顾客应自行对其违法违章行为承担全部责任</div>
      <div class="info">11、顾客应自行妥善保管车内贵重物品、车辆加装物品、可移动物品等所有物品，如发生遗失或损坏，救援师傅和道路救援机构不承担责任</div>
    </div>
    <div class="signContent">
      <div class="subTitle">顾客对上述内容已知晓并接受，准许实施施救服务</div>
      <div v-if="showCustomerSign">顾客签字</div>
      <div
        class="sign"
        @click="goCustomerSign"
        v-if="showCustomerSign"
      >
        <div
          class="signature__pad"
          v-if="!customerSignPath"
        >点击顾客签字</div>
        <img
          class="signature__img"
          v-else
          :src="customerSignPath"
        >
      </div>
      <div>救援师傅签字</div>
      <div
        class="sign"
        @click="goOperatorSign"
      >
        <div
          class="signature__pad"
          v-if="!operatorSignPath"
        >点击救援师傅签字</div>
        <img
          class="signature__img"
          v-else
          :src="operatorSignPath"
        >
      </div>
      <template
        v-if="showPickUpPersonSign && isTrailer && isCCQC"
      >
        <div>接车人签字</div>
        <div
          class="sign"
          @click="goPickUpPersonSign"
        >
          <div
            class="signature__pad"
            v-if="!pickUpPersonSignPath"
          >点击接车人签字</div>
          <img
            class="signature__img"
            v-else
            :src="pickUpPersonSignPath"
          >
        </div>
      </template>
    </div>
    <div class="btn-box">
      <van-row gutter="17">
        <van-col span="12">
          <van-button
            type="default"
            block
            plain
            @click="cancel"
          >取消</van-button>
        </van-col>
        <van-col span="12">
          <van-button
            type="info"
            block
            @click="confirm"
          >确认</van-button>
        </van-col>
      </van-row>
    </div>
    <!-- 确认弹窗 -->
    <ConfirmDialog
      ref="confirmDialog"
    />

  </div>
</template>

<script>
import { getTaskDetail, saveRescueReport, getRescueReport } from '@/common/apiPaic.js';
import { generalProductCode } from '@/common/constant.js';
import jsApi from '@/common/jsApi';
import dayjs from 'dayjs';
import { pushHistory } from '../common/utils';
import ConfirmDialog from '@/components/confirmDialog.vue';
export default {
  name: 'WorkOrders',
  components: {
    ConfirmDialog
  },
  data() {
    return {
      taskDetail: {},
      orderNo: '',
      taskNo: '',
      formList: [
        {
          key: 'categoryCodeName',
          value: '业务类型'
        },
        {
          key: 'payType',
          value: '收费类型'
        },
        {
          key: 'contactName',
          value: '客户名称'
        },
        {
          key: 'orderNo',
          value: '订单编号'
        },
        {
          key: 'carNo',
          value: '车牌号'
        },
        {
          key: 'vinNo',
          value: '车架号'
        },
        {
          key: 'modelName',
          value: '车型'
        },
        {
          key: 'createTime',
          value: '救援日期'
        },
        {
          key: 'arriveMileageInfo',
          value: '救援车辆从出发地到救援地里程（KM）'
        },
        {
          key: 'appealDistanceInfo',
          value: '救援车辆从救援地到目的地里程（KM）'
        },
        {
          key: 'contactAddress',
          value: '救援地'
        },
        {
          key: 'destination',
          value: '目的地'
        },
        {
          key: 'extraProductInfo',
          value: '增值产品'
        }
      ],
      formData: {},
      checkList: ['白天', '夜间', '非雨雪天', '雨雪天', '干净', '脏'],
      dataForm: {
        rescueEnvironment: [],
        carStatus: ''
      },
      customerSignPath: '',
      operatorSignPath: '',
      pickUpPersonSignPath: '',
      useIncomingIsBlackScreens: false,
      isBlackScreens: false,
      isH5: false,
      isFirst: true,
      type: ''
    };
  },
  activated() {
    if (localStorage.getItem('isSign') === '0') {
      this.getRescueReport();
    }
    const customerSignPath = localStorage.getItem('customerSignPath') || '';
    const customerSignPicId = localStorage.getItem('customerSignPicId') || '';
    if (customerSignPath) {
      this.dataForm.customerSign = customerSignPicId; // 保存用id
      this.customerSignPath = customerSignPath;
      localStorage.removeItem('customerSignPath');
      localStorage.removeItem('customerSignPicId');
    }
    const operatorSignPath = localStorage.getItem('operatorSignPath') || '';
    const operatorSignPicId = localStorage.getItem('operatorSignPicId') || '';
    if (operatorSignPath) {
      this.dataForm.operatorSign = operatorSignPicId; // 保存用id
      this.operatorSignPath = operatorSignPath;
      localStorage.removeItem('operatorSignPath');
      localStorage.removeItem('operatorSignPicId');
    }
    const pickUpPersonSignPath = localStorage.getItem('pickUpPersonSignPath') || '';
    const pickUpPersonSignPicId = localStorage.getItem('pickUpPersonSignPicId') || '';
    if (pickUpPersonSignPath) {
      this.dataForm.pickUpPersonSign = pickUpPersonSignPicId; // 保存用id
      this.pickUpPersonSignPath = pickUpPersonSignPath;
      localStorage.removeItem('pickUpPersonSignPath');
      localStorage.removeItem('pickUpPersonSignPicId');
    }
  },
  created() {
    localStorage.removeItem('customerSignPath');
    localStorage.removeItem('customerSignPicId');
    localStorage.removeItem('operatorSignPath');
    localStorage.removeItem('operatorSignPicId');
    localStorage.removeItem('pickUpPersonSignPath');
    localStorage.removeItem('pickUpPersonSignPicId');
    const { orderNo, taskNo } = this.$route.params;
    this.isH5 = this.$route.query.isH5;
    this.type = this.$route.query.type;
    this.useIncomingIsBlackScreens = this.$route.query.useIncomingIsBlackScreens;
    this.isBlackScreens = this.$route.query.isBlackScreens;
    console.log(this.$route.query);
    if (orderNo && taskNo) {
      this.orderNo = orderNo;
      this.taskNo = taskNo;
    }
    this.getRescueReport();
  },
  computed: {
    // 放空，隐藏客户签字
    showCustomerSign() {
      if (this.type === 'evacuation') {
        return false;
      }
      return true;
    },
    // 放空，隐藏接车人签字
    showPickUpPersonSign() {
      if (this.type === 'evacuation') {
        return false;
      }
      return true;
    },
    isCCQC() {
      // 长城汽车
      return this.taskDetail && this.taskDetail.channelCompanyNo === 'CCQC';
    },
    // 拖车
    isTrailer() {
      return this.taskDetail && [generalProductCode.categoryCode_FL10000002, generalProductCode.categoryCode_FL90000002].includes(this.taskDetail.categoryCode);
    },
    // 安盛天平
    isTPBX() {
      return this.taskDetail && this.taskDetail.channelCompanyNo === 'TPBX';
    },
    // 华安
    isHAIC() {
      return this.taskDetail && this.taskDetail.channelCompanyNo === 'HAIC';
    }
  },
  mounted() {
    // 解决首次进入webview时，$router.go(-1)失效的问题
    if (this.isFirst) {
      pushHistory();
      this.$router.go(-1);
      this.isFirst = false;
    }
  },
  methods: {
    async getTaskDetail(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
          this.formData = data;
          const extraProduct = this.taskDetail.extraProduct || [];
          const extraProductStringList = extraProduct.map(item => `${item.name}(${Number(item.value)})`) || [];
          this.formData.extraProductInfo = this.$route.query.extraProduct || extraProductStringList.join(',');
          this.formData.arriveMileageInfo = data.arriveMileage || data.startEstimateDistance || 0;
          this.formData.appealDistanceInfo = data.appealDistance || data.orderMileage || 0;
          this.formData.createTime = this.formData.orderCreateTime ? dayjs(this.formData.orderCreateTime).format('YYYY-MM-DD') : '';
          // 判断华安拖车订单
          if (this.isHAIC && this.isTrailer && !this.dataForm.carStatus) {
            if (this.useIncomingIsBlackScreens) {
              if (this.isBlackScreens) {
                this.dataForm.carStatus = '故障状态无法复现，确需拖车服务';
              }
            } else {
              if (this.taskDetail.blackScreen === 1) {
                this.dataForm.carStatus = '故障状态无法复现，确需拖车服务';
              }
            }
          }
        }
        if (!noLoading) {
          this.$toast.clear();
        }
        try {
          const res = await jsApi.hiddenCancelByStatus({ taskStatus: this.taskDetail.taskStatus, appServiceType: this.taskDetail.appServiceType, orderNo: this.taskDetail.orderNo, taskNo: this.taskDetail.taskNo });
          if (res) {
            console.log(res);
          }
        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getRescueReport() {
      try {
        const data = await getRescueReport({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          // this.dataForm = data;
          this.dataForm.rescueEnvironment = data.rescueEnvironment || [];
          this.customerSignPath = data.customerSign || '';
          this.operatorSignPath = data.operatorSign || '';
          this.pickUpPersonSignPath = data.pickUpPersonSign || '';
          this.dataForm.customerSign = data.customerSignImgId || '';
          this.dataForm.operatorSign = data.operatorSignImgId || '';
          this.dataForm.pickUpPersonSign = data.pickUpPersonSignImgId || '';
          this.dataForm.carStatus = data.carStatus || '';
        }
        this.getTaskDetail();
      } catch (error) {
        console.log(error);
      }
    },
    goCustomerSign() {
      if (this.isTPBX) {
        const that = this;
        that.$refs.confirmDialog.open({
          confirmText: '请签署全名',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmCallback: () => {
            that.$nextTick(() => {
              that.goCustomerSignPage();
            });
          }
        });
      } else {
        this.goCustomerSignPage();
      }
    },
    goCustomerSignPage() {
      this.$router.push({
        path: '/generalOrder/sign',
        query: {
          type: 'customerSign'
        }
      });
    },
    goOperatorSign() {
      this.$router.push({
        path: '/generalOrder/sign',
        query: {
          type: 'operatorSign'
        }
      });
    },
    goPickUpPersonSign() {
      this.$router.push({
        path: '/generalOrder/sign',
        query: {
          type: 'pickUpPersonSign'
        }
      });
    },
    cancel() {
      if (this.isH5) {
        this.$router.go(-1);
      } else {
        jsApi.closeCurrentWebView();
      }
      localStorage.setItem('isSign', 0);
    },
    showRequiredInfo(confirmText) {
      this.$refs.confirmDialog.open({
        confirmText,
        showCancelButton: false,
        confirmButtonText: '确定'
      });
    },
    async confirm(noLoading) {
      // if (this.taskDetail.rescueResult === 1 && !this.dataForm.customerSign) {
      //   this.$toast('请先完善电子工单');
      //   return;
      // }
      if (!this.dataForm.carStatus) {
        this.showRequiredInfo('请填写故障原因');
        return;
      }
      if (!this.dataForm.operatorSign) {
        this.showRequiredInfo('请救援师傅签字');
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        await saveRescueReport({
          taskNo: this.taskNo,
          ...this.dataForm
        });
        this.$toast('保存成功');
        if (!noLoading) {
          this.$toast.clear();
        }
        if (this.isH5) {
          this.$router.go(-1);
        } else {
          setTimeout(function() {
            jsApi.closeCurrentWebView();
          }, 2000);
        }
        localStorage.setItem('isSign', '0');
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.agreement{
  padding: 20px 20px 10px;
  font-size: 14px;
  line-height: 22px;
  .title{
    font-weight: 900;
  }
  .info{
    line-height: 20px;
  }
}
.signContent{
  padding: 0 20px 20px;
  font-size: 14px;
  line-height: 22px;
  .subTitle{
    font-weight: 900;
    margin: 10px 0;
  }
  .signature__pad {
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100vw - 32px);
    height: 150px;
    color: #c8d8eb;
    background-color: #f5f7fa;
    font-size: 16px;
  }

  .signature__img {
    display: flex;
    width: calc(100vw - 32px);
    height: 150px;
  }
  .sign{
    margin: 10px 0;
  }
}
.btn-box{
  padding: 10px 16px 20px;
  box-sizing: border-box;
  .van-button{
    height: 40px;
    padding: 9px 10px;

    text-align: center;
    letter-spacing: -0.38px;

    border-radius: 8px;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    &.van-button--default{
      color: #646464;
      border: 1px solid rgba(200,200,200,1);
      background: #FFFFFF;
    }

    &.van-button--info{
      color: #FFFFFF;
      border: 1px solid #3399FF;
      background: #3399FF;
    }
  }
}
</style>
